import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
var PostAbilityTestTipComponent = (function () {
    function PostAbilityTestTipComponent(route, router, apiService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
    }
    PostAbilityTestTipComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.level = params['level'];
            _this.learningPathId = params['learningPathId'];
        });
    };
    PostAbilityTestTipComponent.prototype.ngAfterViewInit = function () {
        var html = document.documentElement;
        var htmlFontSize = html.clientWidth / 7.5;
        html.style.fontSize = htmlFontSize + "px";
        html.style.backgroundColor = "#3d3d6e";
    };
    PostAbilityTestTipComponent.prototype.close = function () {
        var _this = this;
        if (this.learningPathId == 0) {
            var link = ['learning-map'];
            this.router.navigate(link);
        }
        else {
            this.apiService.ajax({
                'type': 'get',
                'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
            }).subscribe(function (result) {
                var link = ['learning-path', result.data];
                _this.router.navigate(link);
            });
        }
    };
    return PostAbilityTestTipComponent;
}());
export { PostAbilityTestTipComponent };



// WEBPACK FOOTER //
// ./src/app/post-ability-test-tip/post-ability-test-tip.component.ts.pre-build-optimizer.js